export * from './ubiBackTop.component';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/components/ubiBackTop/index.ts